<template>
  <div>
    <!-- Banner -->
    <section id="banner" class="parallax">
      <div class="wrapper bg-cover">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="card filter-home">
                <div class="col-md-2; left">
                  <qrcode-vue
                    class="code_crud"
                    size="120"
                    :value="schedule.room.id.toString()"
                    level="H"
                  ></qrcode-vue>
                </div>
                <div class="card-body">
                  <div
                    class="row"
                    style="margin-top: 15px; padding-left: 150px"
                  >
                    <div class="col-md-11">
                      <label for="title">Título da Reunião</label>
                      <h5>
                        <span class="badge badge-default">{{
                          schedule.title
                        }}</span>
                      </h5>
                    </div>
                  </div>
                  <div
                    class="row"
                    style="margin-top: 25px; padding-left: 150px"
                  >
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="inputPlace">Data Início</label>
                        <h5>
                          <span class="badge badge-default">{{
                            schedule.date_start
                          }}</span>
                        </h5>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="inputPlace">Data Final</label>
                        <h5>
                          <span class="badge badge-default">{{
                            schedule.date_end
                          }}</span>
                        </h5>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="inputPlace">Status</label>
                        <h5 v-if="schedule.status == 1">
                          <span class="badge badge-default">Reservada</span>
                        </h5>
                        <h5 v-if="schedule.status == 2">
                          <span class="badge badge-primary">Confirmada</span>
                        </h5>
                        <h5 v-if="schedule.status == 3">
                          <span class="badge badge-success">Em andamento</span>
                        </h5>
                        <h5 v-if="schedule.status == 4">
                          <span class="badge badge-warning">Finalizada</span>
                        </h5>
                        <h5 v-if="schedule.status == 5">
                          <span class="badge badge-danger">Cancelada</span>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <div class="row text-center">
                    <div class="col">
                      <button class="btn btn-success" @click="checkInReserve">
                        Check-in
                      </button>
                    </div>
                    <div class="col">
                      <button class="btn btn-warning" @click="finishReserve">
                        Finalizar
                      </button>
                    </div>
                    <div class="col">
                      <button class="btn btn-danger" @click="cancelReserve">
                        Cancelar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="rooms">
      <div class="row justify-content-center">
        <h2 class="title justify-content-center">Sala reservada</h2>
      </div>
      <div class="container-fluid">
        <div class="row justify-content-center">
          <!-- Room Card -->
          <div class="col-md-3">
            <div class="card">
              <img class="card-img-top" :src="schedule.room.photo" alt />

              <div class="card-body">
                <div class="room-name">
                  {{ schedule.room.title }}
                  <span class="room-distance">{{ schedule.room.tag }}</span>
                </div>
                <div class="room-name">
                  <span class="room-distance2"
                    >{{ schedule.room.floor }}º Andar</span
                  >
                </div>
                <div class="room-info">
                  <label>Adicionais da Sala</label>
                  <div class="room-place">
                    <span
                      class="badge badge-secondary lg-badge"
                      v-for="detail in schedule.room.details"
                      :key="detail.id"
                      style="padding 3px"
                      >{{ detail.detail.title }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="banner" class="parallax" style="margin-top: 25px">
      <div class="wrapper bg-cover">
        <div class="container">
          <div class="row" align="center">
            <div class="col-md-12">
              <h5>Participantes desta reunião</h5>
              <hr />
            </div>
          </div>
          <div class="row" style="margin-top: -25px; padding: 25px">
            <table class="table table-striped" style="width: 100%">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>E-mail</th>
                  <th>Status</th>
                  <th>Presencial</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="participant in schedule.participants"
                  :key="participant.id"
                >
                  <td width="40%">{{ participant.name }}</td>
                  <td width="40%">{{ participant.email }}</td>
                  <td width="20%">
                    <span
                      class="badge"
                      :class="
                        participant.status == 1
                          ? 'badge-warning'
                          : participant.status == 2
                          ? 'badge-success'
                          : 'badge-danger'
                      "
                      >{{
                        participant.status == 1
                          ? "Aguardando"
                          : participant.status == 2
                          ? "Confirmado"
                          : "Rejeitado"
                      }}</span
                    >
                  </td>
                  <td width="20%">
                    <span
                      class="badge"
                      :class="
                        participant.select_remote == 0
                          ? 'badge-danger'
                          : 'badge-success'
                      "
                      >{{
                        participant.select_remote == 0 ? "Não" : "Sim"
                      }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import vSelect from "vue-select";
import QrcodeVue from "qrcode.vue";

export default {
  data: function () {
    return {
      schedule: {
        room: [],
      },
      users: [],
    };
  },
  components: { vSelect, QrcodeVue },
  methods: {
    checkInReserve() {
      let self = this;
      let api =
        self.$store.getters.api +
        "schedule_rooms/self/" +
        self.$route.params.id;
      self.$http
        .post(api, {
          status: 3,
        })
        .then((response) => {
          self.$message(
            "Sucesso",
            "Reserva atualizada com sucesso!",
            "success"
          );
        })
        .then(() => {
          self.schedule.status = 3;
        });
    },
    finishReserve() {
      let self = this;
      let api =
        self.$store.getters.api +
        "schedule_rooms/self/" +
        self.$route.params.id;
      self.$http
        .post(api, {
          status: 4,
        })
        .then((response) => {
          self.$message(
            "Sucesso",
            "Reserva atualizada com sucesso!",
            "success"
          );
        })
        .then(() => {
          self.schedule.status = 4;
        });
    },
    cancelReserve() {
      let self = this;
      let api =
        self.$store.getters.api +
        "schedule_rooms/self/" +
        self.$route.params.id;
      self.$http
        .post(api, {
          status: 5,
        })
        .then((response) => {
          self.$message(
            "Sucesso",
            "Reserva atualizada com sucesso!",
            "success"
          );
        })
        .then(() => {
          self.schedule.status = 5;
        });
    },
    getSchedule: function () {
      let self = this;
      let id = self.$route.params.id;
      let api =
        self.$store.state.api +
        "schedule_rooms/" +
        id +
        "/?with[]=room&with[]=participants";

      self.$http
        .get(api)
        .then((response) => {
          self.schedule = response.data.data[0];
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted() {
    this.getSchedule();
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.lg-check {
  margin: 20px;
}

.left {
  position: absolute;
  margin-top: 30px;
  margin-right: 950px;
}

.lg-badge {
  margin: 3px;
}

.pointer {
  cursor: pointer;
}

.borderSelected {
  border: 2px solid #222;
  margin-bottom: 1rem;
  box-shadow: inset 0 0 1em #222, 0 0 1em #222;
}

.rowTable {
  border-bottom: 1px solid #222;
  padding: 3px;
  width: 100%;
}

.rowTable:hover {
  border-bottom: 1px solid #222;
  padding: 3px;
  width: 100%;
  background-color: #f0f0f0;
}

input[type="checkbox"] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

input[type="checkbox"] + label {
  font-size: 12px;
  padding: 2px 0 0;
  width: 120px;
  height: 25px;
  border: 2px solid #4b2e8f;
  border-radius: 0.25rem;
}

input[type="checkbox"]:checked + label {
  border: 2px solid #4b2e8f;
  color: #fff;
  background-color: #4b2e8f;
  font-style: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/ScheduleRooms/View.vue